import React from 'react';

export const Datadog = React.lazy((): Promise<typeof import('@/features/Datadog')> => import('@/features/Datadog'));
export const ChargingHub = React.lazy(
  (): Promise<typeof import('@/features/ChargingHub')> => import('@/features/ChargingHub'),
);
export const Header = React.lazy(
  (): Promise<typeof import('@/features/Navigation/Header')> => import('@/features/Navigation/Header'),
);
export const Layout = React.lazy(
  (): Promise<typeof import('@/common/components/Layout')> => import('@/common/components/Layout'),
);
export const PageNotFound = React.lazy(
  (): Promise<typeof import('@/common/components/PageNotFound')> => import('@/common/components/PageNotFound'),
);
export const RouteError = React.lazy(
  (): Promise<typeof import('@/common/components/RouteError')> => import('@/common/components/RouteError'),
);
export const SolutionHomeOverview = React.lazy(
  (): Promise<typeof import('@/features/Solution/SolutionHomeOverview')> =>
    import('@/features/Solution/SolutionHomeOverview'),
);
export const ImportedData = React.lazy(
  (): Promise<typeof import('@/features/ImportedData')> => import('@/features/ImportedData'),
);
export const SolutionManager = React.lazy(
  (): Promise<typeof import('@/features/Solution/SolutionManager')> => import('@/features/Solution/SolutionManager'),
);
export const BevHub = React.lazy(
  (): Promise<typeof import('@/features/Bev/BevHub')> => import('@/features/Bev/BevHub'),
);
export const BevDetail = React.lazy(
  (): Promise<typeof import('@/features/Bev/BevDetail')> => import('@/features/Bev/BevDetail'),
);
export const ImportCandidates = React.lazy(
  (): Promise<typeof import('@/features/ImportCandidates')> => import('@/features/ImportCandidates'),
);
